export class SoTopFiveDetails{
    
    poNumber: string;
    invoiceDate: string;
    actEdlDate: string;
  
}